import React from 'react';
import { makeStyles, Typography, Box } from '@material-ui/core';
import { IconButton } from '@coolremote/shared';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  button: {
    width: '46px',
    height: '28px',
    borderRadius: '6px',
    backgroundColor: 'rgba(255,255,255,0.1)', // Dark grey from design
    color: '#fff',
    padding: 0,
    '&:hover': {
      backgroundColor: 'rgba(255,255,255,0.4)'
    },
    '&.Mui-disabled': {
      backgroundColor: 'rgba(53, 57, 81, 0.5)',
      color: 'rgba(255, 255, 255, 0.3)',
    },
  },
  icon: {
    fontSize: '18px',
  },
  valueText: {
    color: '#fff',
    fontSize: '16px', // slightly larger to match photo
    fontWeight: 400,
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 2,
  },
  unitText: {
    fontSize: '12px',
    color: '#A0A4B8', // Greyish color for the unit
    fontWeight: 'normal',

  },
}));

export interface SetpointPickerProps {
  value: string | number;
  unit?: string;
  onIncrease: () => void;
  onDecrease: () => void;
  disabled?: boolean;
  className?: string;
}

const SetpointPicker: React.FC<SetpointPickerProps> = ({
  value,
  unit,
  onIncrease,
  onDecrease,
  disabled = false,
  className,
}) => {
  const classes = useStyles();

  return (
    <Box className={clsx(classes.container, className)}>
      <IconButton
        className={classes.button}
        onClick={onDecrease}
        disabled={disabled}
        disableRipple
      >
        <RemoveIcon className={classes.icon} />
      </IconButton>

      <Typography className={classes.valueText}>
        {value}
        {unit && <span className={classes.unitText}>{unit}</span>}
      </Typography>

      <IconButton
        className={classes.button}
        onClick={onIncrease}
        disabled={disabled}
        disableRipple
      >
        <AddIcon className={classes.icon} />
      </IconButton>
    </Box>
  );
};

export default SetpointPicker;
